import {IMiniProduct} from "./IMiniProduct";

export interface ICartItem {
  product: IMiniProduct,
  quantity: number,
  positionId: number,
  shoppingListId: number,
  setupOptions?: ICartSetupOptionItem[]
}

export function toAppShopCartProduct(cartItem: ICartItem) {

  return {
    shopProductQuantity: {
      productID: cartItem.product.productID,
      quantity: cartItem.quantity
    },
    productOptionsContext: cartItem.setupOptions!=null ? cartItem.setupOptions.map((setupOption: ICartSetupOptionItem) => {
      return {
        productId: setupOption.productId,
        setupProductId: setupOption.setupProductId,
        optionSetId: setupOption.optionSetId,
        optionId: setupOption.optionId,
        quantity: setupOption.quantity,
      }
    }) : null
  }
}

export interface ICartSetupOptionItem {
  productId: number,
  name?: string,
  price?: number,
  priceCurrency?: string,
  setupProductId: number,
  optionSetId: number,
  optionId: number,
  remark: string,
  quantity: string
}

export interface ISetupOption {
  productId: number,
  optionSetId: number,
  optionId: number,
  name: string,
  price: string,
  filepath: string
}
